<template>
  <Base :base-id="'lb-get-product-mail'" :base-class="'modal-sm'">
    <template #header>
      <h4 class="modal-title">貨到通知</h4>
    </template>
    <template #body>
      <input
        v-model.trim="userMail"
        type="email"
        name="mail"
        placeholder="請輸入E-mail"
        class="form-control"
      />
      <div v-show="regexError" class="error">請輸入有效Email</div>
      <p class="mt-1">提醒您，此貨到通知不提供商品保留功能</p>
    </template>
    <template #footer>
      <div class="w-100">
        <button type="button" class="btn w-100" @click.prevent="getNotice">提交</button>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

import Base from '@global/components/common/modal/Base.vue';

import useModalStore from '@global/stores/useModalStore';

import useAlert from '@global/composable/useAlert';
import useAPIHandler from '@global/composable/api/useAxiosAPI';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);
const { alertDialog } = useAlert();
const { postNoticeAPI } = useAPIHandler();

const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

const userMail = ref('');
const regexError = ref(false);

watch(userMail, (newVal) => {
  regexError.value = !regex.test(newVal);
});

function getNotice() {
  if (userMail.value && regex.test(userMail.value)) {
    postNoticeAPI({
      CustomMarketID: modalData.value,
      Email: userMail.value,
    })
      .then((res) => {
        if (res.data.Code === 200) {
          alertDialog.alert('貨到通知索取成功!謝謝您~', () => {
            closeModal();
          });
        } else {
          closeModal();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    regexError.value = true;
  }
}
</script>
